import { Divider } from "antd";

import { authSelector } from "../../../../app/features/auth/auth.slice";
import { useAppSelector } from "../../../../hooks/redux.hook";

import FaIcon from "../../../../components/global/FaIcon";

import { EMPTY_TEXT } from "../../../../utils/enum/defaultParams.enum";

const DashboardFooter = () => {
  const { user, brand } = useAppSelector(authSelector);

  return (
    <div className="relative -mt-7 -top-[5px] text-xs xl:text-md border-t bg-white shadow px-4 py-2 z-10">
      <div className="flex items-center">
        <div className="flex items-center"></div>
        <div className="ml-auto">
          <FaIcon icon="store" classes="mr-0" />
          <span className="ml-1">Dominio: </span>
          <span className="font-semibold ml-1">{brand?.name ?? EMPTY_TEXT}</span>
        </div>
        <Divider type="vertical" />
        <div>
          <FaIcon icon="user-lock" classes="mr-0" />
          <span className="ml-1">Usuario: </span>
          <span className="font-semibold ml-1">{user?.username ?? EMPTY_TEXT}</span>
        </div>
      </div>
    </div>
  );
};

export default DashboardFooter;
